import { useCallback } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import RoleModel from "../../shared/role-model";
import HttpClient from "../http-client";
const size = 20;

/* eslint-disable-next-line */
export interface RoleSelectorProps {
  value?: RoleModel;
  onChange?: (value?: RoleModel) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

export function RoleSelector({
  value,
  onChange,
  className,
  placeholder,
  disabled,
}: RoleSelectorProps) {
  const loadOptions = useCallback(async (name: string, _, { page }) => {
    try {
      const { data } = await HttpClient.get(
        `user/roles?name=${name}&page=${page}&size=${size}`
      );
      const options = Array.isArray(data?.data) ? data?.data : [];
      return {
        options,
        hasMore: options.length >= size,
        additional: {
          page: page + 1,
        },
      };
    } catch (e) {}

    return {
      options: [],
      hasMore: false,
    };
  }, []);
  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      getOptionLabel={(option: RoleModel) => option.name!}
      getOptionValue={(option: RoleModel) => option.id!}
      onChange={(val) => onChange?.(val as RoleModel)}
      additional={{
        page: 1,
      }}
      menuPlacement="auto"
      className={className}
      placeholder={placeholder ?? "Select role"}
      isDisabled={disabled}
    />
  );
}

export default RoleSelector;
